import { referenceVersionConnectionService } from "../../../services/connections/referenceVersionService";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import {
  ReferenceVersionConnection,
  SystemVersionConnectionDirection,
  SystemVersionReferenceToEntity,
} from "../../../types/referenceVersion";
import useReferenceVersionLogic from "../../logic/connections/referenceVersionLogic";
import useConnectionQueryClient from "./connectionQueryClient";

const useReferenceVersionQuery = (
  referenceToEntity: SystemVersionReferenceToEntity | null = null,
  connectionDirection: SystemVersionConnectionDirection | null = null
) => {
  const { defaultReferenceVersion, getDisplayName } = useReferenceVersionLogic(
    null,
    null,
    referenceToEntity,
    connectionDirection
  );
  return useConnectionQueryClient<ReferenceVersionConnection>({
    service: referenceVersionConnectionService,
    defaultConnection: defaultReferenceVersion,
    collection: SystemEntityCollections.REFERENCE_VERSION,
    snackbarDisplayName: getDisplayName,
  });
};

export default useReferenceVersionQuery;
